import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";

import { getAdminInfo } from "../../core/admin.core";
import { createManualCashTransaction } from "../../core/manualCashTransaction.core";
import { useTranslation } from "../../core/translation.core";

export default function ManualTransactionPanel({ setIsOpen }: { setIsOpen: any }) {
  const [type, setType] = useState("");
  const { t, msg } = useTranslation();
  const [amount, setAmount] = useState<number>();
  const [reason, setReason] = useState<string>();
  const queryClient = useQueryClient();

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const { data: me } = useQuery({
    queryFn: () => getAdminInfo(),
    queryKey: ["admin"],
  });

  async function addManualTrans() {
    const payload = {
      amount: Number(amount),
      createdBy: me._id,
      reason,
      type,
    };

    if (!type) {
      return toast.error(t(msg.errors.selectTransactionType));
    }

    //  @ts-ignore
    if (amount <= 0) {
      return toast.error(t(msg.errors.amtGreaterThanZero));
    }

    if (!reason) {
      return toast.error(t(msg.errors.reasonRequired));
    }

    if (amount) {
      await createManualCashTransaction(payload)
        .then((msg: any) => {
          toast.success(msg.message);
          queryClient.invalidateQueries({ queryKey: ["cash-register"] });
          queryClient.invalidateQueries({ queryKey: ["single-register"] });
          setAmount(0);
          setReason("");
          setIsOpen(false);
        })
        .catch((err: any) => {
          if (err.message.includes("Insufficient balance")) return toast.error(t(msg.errors.insufficientBalance));
          toast.error(t(msg.errors.contactAdmin));
        });
    }
  }

  return (
    <div className="rounded-lg h-fit px-4 flex flex-col space-y-6 text-black text-sm">
      <select className="p-2 rounded-md border outline-none text-gray-700" value={type} onChange={handleChange}>
        <option value="" disabled>
          {t(msg.cash.selectTransactionType)}
        </option>
        <option value="deposit">{t(msg.checkout.deposit)}</option>
        <option value="withdrawal">{t(msg.cash.withdrawal)}</option>
      </select>

      <input
        value={amount}
        onChange={(e) => setAmount(Number(e.target.value))}
        type="text"
        placeholder={t(msg.checkout.enterAmount)}
        className="p-3 rounded-md border outline-none"
      />

      <textarea
        rows={5}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={t(msg.formLabels.enterReason)}
        className="py-4 px-2 rounded-md border outline-none"
      />

      <button onClick={addManualTrans} className="bg-her-blue text-white p-3 font-bold rounded-md shadow-sm">
        {t(msg.form.submit)}
      </button>
    </div>
  );
}
